import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-plus\">\n<path d=\"M58.3,542h420v420c0,16.6,13.4,30,30,30c16.6,0,30-13.4,30-30V542h420c16.6,0,30-13.4,30-30s-13.4-30-30-30h-420V62\n\tc0-16.6-13.4-30-30-30s-30,13.4-30,30v420h-420c-16.6,0-30,13.4-30,30C28.3,528.6,41.7,542,58.3,542z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol